import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-article-line",
    title: "内容策划",
    desc: "围绕影视、音乐与生活方式，提供专题策划与内容制作。",
  },
  {
    icon: "ri-megaphone-line",
    title: "品牌传播",
    desc: "用真实、有温度的内容，帮品牌讲好自己的故事。",
  },
  {
    icon: "ri-team-line",
    title: "共创合作",
    desc: "面向创作者与机构，开放栏目共建与联合出品。",
  },
];

export default function BrandIntro() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="bg-primary-50 border border-primary-100 rounded-lg overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10 flex flex-col justify-center">
            <span className="inline-flex items-center gap-2 self-start text-xs text-primary-700 bg-background-50 px-3 py-1 rounded-full">
              <i className="ri-plant-line"></i>
              小蜜桃品牌服务
            </span>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
              让好内容，被更多人温柔地看见
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              小蜜桃不只是资讯聚合，我们更愿意和品牌、创作者一起，
              把值得被看见的人和事，用更轻松的方式讲出来。
            </p>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {services.map((s) => (
                <div key={s.title} className="flex flex-col">
                  <span className="w-9 h-9 rounded-lg bg-background-50 text-primary-600 flex items-center justify-center">
                    <i className={`${s.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-semibold text-foreground-900">
                    {s.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-600 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link
                to="/brand"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm px-5 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                了解品牌服务
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 bg-background-50 hover:bg-background-100 text-foreground-800 text-sm px-5 py-2.5 rounded-md border border-background-200 transition-colors cursor-pointer whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>

          <div className="h-56 lg:h-auto min-h-[240px] bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=creative%20editorial%20team%20meeting%20scene%2C%20bright%20modern%20studio%20with%20orange%20and%20cream%20tones%2C%20people%20discussing%20around%20colorful%20storyboards%2C%20warm%20natural%20light%2C%20clean%20minimal%20composition%2C%20professional%20lifestyle%20photography&width=900&height=800&seq=xmt-brand-intro&orientation=squarish"
              alt="小蜜桃品牌服务团队 - 内容策划与品牌传播"
              title="小蜜桃品牌服务 - 内容策划与品牌传播"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}